export default __webpack_public_path__ + "static/media/icon-diferencial.24a87c85.svg";